export function Footer() {
  return <div className="m-8"/>;
}
